import { render, staticRenderFns } from "./slaughterhouse.vue?vue&type=template&id=5fc1932f&scoped=true"
import script from "./slaughterhouse.vue?vue&type=script&lang=js"
export * from "./slaughterhouse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fc1932f",
  null
  
)

export default component.exports